import React, { FC } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import LinkTo from "../../linkTo/LinkTo";
import Image from "../../image/Image";
import { LinkType } from "../../../types";

// Interface

export interface ImageButtonProps {
  link: LinkType;
  imageSrc: string;
  imageAlt: string;
}

// Styles

const StyledImage = styled(Image)`
  ${({ theme: { space } }) => css`
    max-width: 135px;
  `};
`;

// JSX

export const ImageButton: FC<ImageButtonProps> = ({
  link,
  imageSrc,
  imageAlt,
}) => (
  <LinkTo to={link?.url} target={link?.label} title={link?.label}>
    <StyledImage src={imageSrc} alt={imageAlt} />
  </LinkTo>
);

export default ImageButton;
